import React from 'react';
import { BookOpenIcon, BrainCircuitIcon, HomeIcon } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    icon: BookOpenIcon,
    emoji: '📘',
    text: 'Leés'
  }, {
    icon: BrainCircuitIcon,
    emoji: '🧠',
    text: 'Comprendés'
  }, {
    icon: HomeIcon,
    emoji: '🏡',
    text: 'Aplicás'
  }];
  return <section className="w-full bg-[#FDF8F3] py-16 px-4" data-id="element-234">
      <div className="max-w-4xl mx-auto text-center" data-id="element-235">
        <span className="inline-block text-[#8B9E7E] font-bold text-lg mb-4" data-id="element-236">
          🌱 LA SOLUCIÓN
        </span>

        <h2 className="text-3xl sm:text-4xl font-bold text-[#5C4033] mb-6" data-id="element-237">
          CRIANZA MONTESSORI EN CASA
        </h2>

        <p className="text-xl text-[#8B7355] mb-6 max-w-3xl mx-auto" data-id="element-238">
          Un sistema completo, práctico y amoroso, creado para familias reales.
        </p>

        <p className="text-lg text-[#8B7355]/90 mb-12 max-w-2xl mx-auto italic" data-id="element-239">
          No es solo teoría linda. No es solo inspiración.
          <br data-id="element-240" />
          Es una estructura paso a paso que te acompaña en la vida cotidiana.
        </p>

        {/* 3-Step Process */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-12 mb-10" data-id="element-241">
          {steps.map((step, index) => <div key={index} className="flex items-center gap-4 sm:gap-12" data-id="element-242">
              <div className="flex flex-col items-center" data-id="element-243">
                <div className="w-24 h-24 bg-[#E8EDE5] rounded-full flex items-center justify-center mb-4 shadow-sm" data-id="element-244">
                  <span className="text-5xl" data-id="element-245">{step.emoji}</span>
                </div>
                <span className="text-xl font-bold text-[#5C4033]" data-id="element-246">
                  {step.text}
                </span>
              </div>
              {index < steps.length - 1 && <span className="hidden sm:block text-3xl text-[#E8EDE5]" data-id="element-247">
                  →
                </span>}
            </div>)}
        </div>
      </div>
    </section>;
}